/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { TimeWindowType } from "graphql/public/generated_public";

import { FadeInOutView, Text } from "UpduoLibrary";
import { formattedTimeWindowTime } from "config/Utilities";
import {
  colorWithOpacity,
  skaleBlack,
  upduoPrimaryBlack,
  upduoPrimaryBlue,
} from "config/UpduoColors";

interface TimeWindowDescriptionModalProps {
  isVisible: boolean;
  timeWindows: Array<TimeWindowType>;
}

export default function TimeWindowDescriptionModal({
  isVisible,
  timeWindows,
}: TimeWindowDescriptionModalProps) {
  const timeWindowRows = timeWindows.map((timeWindow, index) => (
    <Text
      key={index}
      style={{
        color: upduoPrimaryBlack,
        marginBottom: 4,
      }}
    >
      <Text
        style={{
          color: upduoPrimaryBlue,
          fontWeight: "bold",
        }}
      >
        {`${timeWindow.text}\n`}
      </Text>
      {formattedTimeWindowTime(timeWindow)}
    </Text>
  ));

  if (!isVisible) {
    return null;
  }

  return (
    <FadeInOutView
      style={{
        zIndex: 1000,
        backgroundColor: "white",
        position: "absolute",
        top: "50%",
        right: "5%",
        borderRadius: 12,
        width: 350,
        padding: 20,
        shadowColor: colorWithOpacity(skaleBlack, 0.25),
        shadowRadius: 10,
      }}
    >
      <Text
        style={{
          fontSize: 16,
          color: upduoPrimaryBlack,
          fontWeight: "bold",
          lineHeight: 20,
          marginBottom: 12,
          textAlign: "center",
        }}
      >
        {"Upduo Time Windows"}
      </Text>
      <Text
        style={{
          color: upduoPrimaryBlack,
          lineHeight: 17,
          marginBottom: 12,
          textAlign: "center",
        }}
      >
        {
          "Daily time windows reduce wait time and allow for easier matching within your community."
        }
      </Text>
      <Text
        style={{
          color: upduoPrimaryBlack,
          lineHeight: 17,
          marginBottom: 12,
          textAlign: "center",
        }}
      >
        {'Please press "'}
        <Text style={{ fontWeight: "bold" }}>{"connect"}</Text>
        {'" and join an Upduo session during the following time'}
        {timeWindows.length === 1 ? ":" : "s:"}
      </Text>
      {timeWindowRows}
    </FadeInOutView>
  );
}
